import { GenericCell } from '@components/design/migrated/Table';
import { ProductsCellClassType } from '@models/Products';
import * as styles from '@components/top-selling-products/products-table-cell/ProductTableCell.module.scss';
import ProductsTableGenericCell from '@components/top-selling-products/products-table-generic-cell/ProductsTableGenericCell';

interface Props {
  headerName: string;
  colSpan?: number;
}

const ProductsCompareModalKpiCell: React.FC<Props> = ({ headerName, colSpan }) => {
  return (
    <ProductsTableGenericCell
      key={headerName}
      cellKey={headerName}
      classType={ProductsCellClassType.TOTAL}
      colSpan={colSpan}
    >
      <div className={styles.ProductTableCell__TableCell_Item}>
        <GenericCell
          alignment="left"
          primary={<span className={styles.GenericCell__Title}>{headerName}</span>}
          className={styles.GenericCell}
        />
      </div>
    </ProductsTableGenericCell>
  );
};

export default ProductsCompareModalKpiCell;
